type SectionHeadingProps = {
  children: string
  // Heading level — the inline detail nests under a row heading, so it uses h4; the drawer and the
  // usage table sit at the section top, so they use h3 (default).
  as?: "h3" | "h4"
  // Optional id so a sibling (e.g. the usage table) can name itself via aria-labelledby.
  id?: string
};

export const SectionHeading = ({ children, as: Tag = "h3", id }: SectionHeadingProps) => (
  <Tag id={id} className="mb-2.5 text-[11px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
    {children}
  </Tag>
);

SectionHeading.displayName = "SectionHeading";
